export const latestParis = [
  {
    LL_ID: "ce7887fa-8e62-46d5-b821-3f1310ecbeb4",
    ll_name: "City Cosy Paris",
    RU_ID: "394,064",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,000",
    "Price vs Market": "30",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "300",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/394064",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "620,267",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Panth�on",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,012",
    "Price vs Market": "-368",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/620267",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "259,861",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,028",
    "Price vs Market": "-462",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/259861",
  },
  {
    LL_ID: "c91756df-acb4-4f8f-8117-bdca8505a261",
    ll_name: "Henri Sitbon",
    RU_ID: "126,566",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,040",
    "Price vs Market": "-110",
    Available_From: "Apr 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/126566",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "333,318",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,050",
    "Price vs Market": "0",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/333318",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "412,976",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Observatoire",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,082",
    "Price vs Market": "-68",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/412976",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,117",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Reuilly",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,090",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626117",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,116",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Reuilly",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,090",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626116",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,133",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,090",
    "Price vs Market": "100",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626133",
  },
  {
    LL_ID: "9d5b9b4a-790d-4a32-83fa-86207a5f559e",
    ll_name: "DoveVivo France",
    RU_ID: "640,523",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Gobelins",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,140",
    "Price vs Market": "370",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640523",
  },
  {
    LL_ID: "15aa4805-1f99-4486-bca4-170ea8859fa9",
    ll_name: "Merline Ngnietedem",
    RU_ID: "137,276",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Batignolles-Monceau",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,150",
    "Price vs Market": "-150",
    Available_From: "Feb 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/137276",
  },
  {
    LL_ID: "9d5b9b4a-790d-4a32-83fa-86207a5f559e",
    ll_name: "DoveVivo France",
    RU_ID: "639,478",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,180",
    "Price vs Market": "30",
    Available_From: "Feb 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/639478",
  },
  {
    LL_ID: "9d5b9b4a-790d-4a32-83fa-86207a5f559e",
    ll_name: "DoveVivo France",
    RU_ID: "639,479",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,210",
    "Price vs Market": "60",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/639479",
  },
  {
    LL_ID: "ba60eca3-629f-4f65-a940-a8725de4dfee",
    ll_name: "In Beau Paris",
    RU_ID: "334,435",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Gobelins",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,240",
    "Price vs Market": "240",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/334435",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,251",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,245",
    "Price vs Market": "55",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626251",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,252",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,275",
    "Price vs Market": "85",
    Available_From: "Mar 8, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626252",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "396,676",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,290",
    "Price vs Market": "-400",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/396676",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "602,011",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Batignolles-Monceau",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,290",
    "Price vs Market": "-100",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/602011",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "480,283",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,295",
    "Price vs Market": "-285",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/480283",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "131,744",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,300",
    "Price vs Market": "-190",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/131744",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "455,120",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Reuilly",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,425",
    "Price vs Market": "-275",
    Available_From: "Mar 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/455120",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "519,276",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Vaugirard",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,440",
    "Price vs Market": "40",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/519276",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "439,485",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Vaugirard",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,450",
    "Price vs Market": "-370",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/439485",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "413,062",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,450",
    "Price vs Market": "-350",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/413062",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "405,193",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Batignolles-Monceau",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,450",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/405193",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "519,267",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,450",
    "Price vs Market": "480",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/519267",
  },
  {
    LL_ID: "edec5896-9174-490a-a931-e0a9e5d9736d",
    ll_name: "Lionel NKAMSAO",
    RU_ID: "639,295",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,469",
    "Price vs Market": "",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/639295",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "372,141",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,473",
    "Price vs Market": "423",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/372141",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "154,729",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Louvre",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-695",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/154729",
  },
  {
    LL_ID: "ce7887fa-8e62-46d5-b821-3f1310ecbeb4",
    ll_name: "City Cosy Paris",
    RU_ID: "156,293",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Louvre",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,500",
    "Price vs Market": "-680",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "300",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/156293",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "400,956",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Louvre",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,500",
    "Price vs Market": "-680",
    Available_From: "Mar 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/400956",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "396,382",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "1,500",
    "Price vs Market": "",
    Available_From: "Apr 15, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/396382",
  },
  {
    LL_ID: "5cf52b63-0883-4ad1-b24d-cc4377d40cf1",
    ll_name: "Guest Ready France",
    RU_ID: "599,410",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Buttes-Chaumont",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,520",
    "Price vs Market": "680",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/599410",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "228,772",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,550",
    "Price vs Market": "-60",
    Available_From: "Mar 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/228772",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "435,498",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,585",
    "Price vs Market": "-395",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/435498",
  },
  {
    LL_ID: "28f2f757-04cc-4e52-8aa9-aaf8fdc49d9f",
    ll_name: "Robert Setrouk",
    RU_ID: "128,368",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "1,600",
    "Price vs Market": "",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/128368",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "446,322",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,650",
    "Price vs Market": "-540",
    Available_From: "Apr 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/446322",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "511,751",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,670",
    "Price vs Market": "350",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/511751",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "139,092",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,685",
    "Price vs Market": "195",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/139092",
  },
  {
    LL_ID: "a926d616-2a06-4f6c-ae93-c1b21241591c",
    ll_name: "Lokim (No gestion)",
    RU_ID: "222,982",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,690",
    "Price vs Market": "-500",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/222982",
  },
  {
    LL_ID: "80b4754c-4f48-4f36-8e67-cbf05fd1f12d",
    ll_name: "Pascale Tannous",
    RU_ID: "204,123",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Op�ra",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 1,
    Price: "1,690",
    "Price vs Market": "520",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/204123",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "259,844",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,736",
    "Price vs Market": "246",
    Available_From: "Feb 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/259844",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "432,806",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,750",
    "Price vs Market": "260",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/432806",
  },
  {
    LL_ID: "80b4754c-4f48-4f36-8e67-cbf05fd1f12d",
    ll_name: "Pascale Tannous",
    RU_ID: "206,069",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Op�ra",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,790",
    "Price vs Market": "100",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/206069",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "259,831",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,806",
    "Price vs Market": "-554",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/259831",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "259,905",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,806",
    "Price vs Market": "-384",
    Available_From: "Mar 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/259905",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "463,816",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Passy",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,820",
    "Price vs Market": "-20",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/463816",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "602,013",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Observatoire",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,820",
    "Price vs Market": "0",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/602013",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "212,563",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,850",
    "Price vs Market": "-240",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/212563",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "121,668",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,850",
    "Price vs Market": "-200",
    Available_From: "Apr 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/121668",
  },
  {
    LL_ID: "ba60eca3-629f-4f65-a940-a8725de4dfee",
    ll_name: "In Beau Paris",
    RU_ID: "217,414",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "1,870",
    "Price vs Market": "-1,230",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/217414",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "636,994",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,900",
    "Price vs Market": "-250",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/636994",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "413,053",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Gobelins",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "1,925",
    "Price vs Market": "-1,305",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/413053",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "568,107",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,925",
    "Price vs Market": "-55",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/568107",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "619,462",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Vaugirard",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,926",
    "Price vs Market": "106",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/619462",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "142,951",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Panth�on",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,950",
    "Price vs Market": "190",
    Available_From: "Apr 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/142951",
  },
  {
    LL_ID: "ba60eca3-629f-4f65-a940-a8725de4dfee",
    ll_name: "In Beau Paris",
    RU_ID: "236,986",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Gobelins",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "1,960",
    "Price vs Market": "-1,270",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/236986",
  },
  {
    LL_ID: "5cf52b63-0883-4ad1-b24d-cc4377d40cf1",
    ll_name: "Guest Ready France",
    RU_ID: "404,536",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Luxembourg",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,972",
    "Price vs Market": "582",
    Available_From: "Apr 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/404536",
  },
  {
    LL_ID: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    RU_ID: "266,287",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Op�ra",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,972",
    "Price vs Market": "792",
    Available_From: "Mar 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/266287",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "413,029",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,020",
    "Price vs Market": "560",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/413029",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "576,977",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,050",
    "Price vs Market": "0",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/576977",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "433,921",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,075",
    "Price vs Market": "155",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/433921",
  },
  {
    LL_ID: "3dbdc431-d072-41dc-81e4-ec4af87bb978",
    ll_name: "Manage Immo",
    RU_ID: "265,629",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,100",
    "Price vs Market": "-100",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/265629",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "435,500",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,150",
    "Price vs Market": "-50",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/435500",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "217,155",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,200",
    "Price vs Market": "510",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/217155",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "636,790",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Panth�on",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,250",
    "Price vs Market": "940",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/636790",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "396,399",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,250",
    "Price vs Market": "",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/396399",
  },
  {
    LL_ID: "ba60eca3-629f-4f65-a940-a8725de4dfee",
    ll_name: "In Beau Paris",
    RU_ID: "334,421",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,282",
    "Price vs Market": "592",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/334421",
  },
  {
    LL_ID: "19966e06-87d7-4a69-8b0c-6e25810e1c27",
    ll_name: "Martine BOULET",
    RU_ID: "389,877",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,300",
    "Price vs Market": "110",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/389877",
  },
  {
    LL_ID: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    RU_ID: "476,176",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Temple",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,300",
    "Price vs Market": "320",
    Available_From: "Mar 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/476176",
  },
  {
    LL_ID: "6990cbd3-f04e-4355-a1aa-87aabc243db6",
    ll_name: "United Services Company",
    RU_ID: "630,902",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Batignolles-Monceau",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,550",
    "Price vs Market": "-550",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/630902",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "601,987",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,568",
    "Price vs Market": "-532",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/601987",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "601,996",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,568",
    "Price vs Market": "1,068",
    Available_From: "Mar 29, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/601996",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "477,078",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Palais-Bourbon",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,700",
    "Price vs Market": "160",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/477078",
  },
  {
    LL_ID: "5cf52b63-0883-4ad1-b24d-cc4377d40cf1",
    ll_name: "Guest Ready France",
    RU_ID: "440,177",
    Verified: "no",
    City: "paris",
    Neigbourhood: "�lys�e",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,912",
    "Price vs Market": "1,422",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/440177",
  },
  {
    LL_ID: "5cf52b63-0883-4ad1-b24d-cc4377d40cf1",
    ll_name: "Guest Ready France",
    RU_ID: "430,149",
    Verified: "no",
    City: "paris",
    Neigbourhood: "H�tel-de-Ville",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,038",
    "Price vs Market": "358",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/430149",
  },
  {
    LL_ID: "64242c1d-8365-488c-bca3-71430d1c5d04",
    ll_name: "PFA Travel",
    RU_ID: "426,208",
    Verified: "no",
    City: "paris",
    Neigbourhood: "�lys�e",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,150",
    "Price vs Market": "1,100",
    Available_From: "Apr 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/426208",
  },
  {
    LL_ID: "6990cbd3-f04e-4355-a1aa-87aabc243db6",
    ll_name: "United Services Company",
    RU_ID: "628,125",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,400",
    "Price vs Market": "760",
    Available_From: "Apr 29, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/628125",
  },
  {
    LL_ID: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    RU_ID: "620,259",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Vaugirard",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,745",
    "Price vs Market": "1,145",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "20",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/620259",
  },
  {
    LL_ID: "aacb22b3-e9b8-4045-b59d-6b33300d8efc",
    ll_name: "Upperkey",
    RU_ID: "480,394",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Louvre",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,563",
    "Price vs Market": "2,203",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/480394",
  },
  {
    LL_ID: "224c1efe-d44b-434a-a06a-125c1d5b3c8c",
    ll_name: "Yuntao Peng",
    RU_ID: "340,788",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "580",
    "Price vs Market": "-20",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/340788",
  },
  {
    LL_ID: "e1182cf2-1f6c-4261-8b5e-63060091e9fe",
    ll_name: "Mariam Rosier",
    RU_ID: "339,401",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Buttes-Chaumont",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "599",
    "Price vs Market": "-81",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/339401",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "615,482",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/615482",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "615,481",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/615481",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "615,480",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/615480",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,682",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637682",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,683",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637683",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,684",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637684",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,685",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637685",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,686",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637686",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "637,687",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/637687",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "615,479",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/615479",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,780",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Mar 14, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640780",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,763",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640763",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,766",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640766",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,764",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640764",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,785",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640785",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,745",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Feb 25, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640745",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,762",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640762",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,765",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640765",
  },
  {
    LL_ID: "cf0e1ae8-a7e6-47e0-aa6f-ce738c411ac4",
    ll_name: "Kalina Payet",
    RU_ID: "640,761",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "600",
    "Price vs Market": "70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "tcvPercentage",
    Admin_Fee_Value: "5",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640761",
  },
  {
    LL_ID: "4b207cb0-5805-4051-94a5-d965522a8c1d",
    ll_name: "Narjes Djebari",
    RU_ID: "641,076",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "601",
    "Price vs Market": "",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/641076",
  },
  {
    LL_ID: "4b207cb0-5805-4051-94a5-d965522a8c1d",
    ll_name: "Narjes Djebari",
    RU_ID: "641,077",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "601",
    "Price vs Market": "",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/641077",
  },
  {
    LL_ID: "4b207cb0-5805-4051-94a5-d965522a8c1d",
    ll_name: "Narjes Djebari",
    RU_ID: "641,075",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "601",
    "Price vs Market": "",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/641075",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,205",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "640",
    "Price vs Market": "-110",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626205",
  },
  {
    LL_ID: "46687cbb-17ab-4acc-9fdb-aed70db496da",
    ll_name: "Corinne Jahn",
    RU_ID: "515,626",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "640",
    "Price vs Market": "0",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/515626",
  },
  {
    LL_ID: "46687cbb-17ab-4acc-9fdb-aed70db496da",
    ll_name: "Corinne Jahn",
    RU_ID: "515,624",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "640",
    "Price vs Market": "0",
    Available_From: "Feb 22, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/515624",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,203",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626203",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,190",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Feb 22, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626190",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,189",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626189",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,146",
    Verified: "no",
    City: "paris",
    Neigbourhood: "M�nilmontant",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "-70",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626146",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,147",
    Verified: "no",
    City: "paris",
    Neigbourhood: "M�nilmontant",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "-70",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626147",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,152",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "-70",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "790",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626152",
  },
  {
    LL_ID: "e99b7828-ffca-4913-a512-bc8c2d11a3f0",
    ll_name: "Julienne Bossik",
    RU_ID: "415,662",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "60",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/415662",
  },
  {
    LL_ID: "e99b7828-ffca-4913-a512-bc8c2d11a3f0",
    ll_name: "Julienne Bossik",
    RU_ID: "415,661",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "60",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/415661",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,186",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "670",
    "Price vs Market": "-80",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626186",
  },
  {
    LL_ID: "67ae2ca0-58a0-4702-a9f3-56a830217b7b",
    ll_name: "Gabriel Cohen",
    RU_ID: "403,808",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "670",
    "Price vs Market": "10",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/403808",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,031",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "720",
    "Price vs Market": "-70",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626031",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,029",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "720",
    "Price vs Market": "-70",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626029",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "640,179",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "720",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640179",
  },
  {
    LL_ID: "8ff1d670-0449-4da7-87f6-2eb9601b4177",
    ll_name: "Antonio Silva",
    RU_ID: "106,188",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Batignolles-Monceau",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "740",
    "Price vs Market": "-160",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/106188",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,212",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "740",
    "Price vs Market": "-10",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626212",
  },
  {
    LL_ID: "8ff1d670-0449-4da7-87f6-2eb9601b4177",
    ll_name: "Antonio Silva",
    RU_ID: "451,388",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-150",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/451388",
  },
  {
    LL_ID: "8ff1d670-0449-4da7-87f6-2eb9601b4177",
    ll_name: "Antonio Silva",
    RU_ID: "98,414",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-150",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/98414",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,024",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "-100",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626024",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,023",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "-100",
    Available_From: "Mar 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626023",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,030",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-40",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626030",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,220",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626220",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,218",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626218",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,215",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626215",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,201",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Feb 21, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626201",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,021",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626021",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,017",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "750",
    "Price vs Market": "0",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626017",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,149",
    Verified: "no",
    City: "paris",
    Neigbourhood: "M�nilmontant",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "30",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626149",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,143",
    Verified: "no",
    City: "paris",
    Neigbourhood: "M�nilmontant",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "30",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626143",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,070",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "755",
    "Price vs Market": "-125",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626070",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,025",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "760",
    "Price vs Market": "-90",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626025",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,214",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "760",
    "Price vs Market": "10",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626214",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,221",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "770",
    "Price vs Market": "20",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626221",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,217",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "770",
    "Price vs Market": "20",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626217",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,109",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "780",
    "Price vs Market": "-100",
    Available_From: "Mar 5, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626109",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,067",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "780",
    "Price vs Market": "-100",
    Available_From: "Mar 13, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626067",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,093",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "785",
    "Price vs Market": "-95",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626093",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,027",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "790",
    "Price vs Market": "-60",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626027",
  },
  {
    LL_ID: "0275d7ed-5e9d-454e-a41c-c734225a3333",
    ll_name: "Sophiia Dehe",
    RU_ID: "608,331",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "800",
    "Price vs Market": "0",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/608331",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "122,845",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Louvre",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "814",
    "Price vs Market": "-286",
    Available_From: "Mar 23, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/122845",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,110",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "820",
    "Price vs Market": "-60",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626110",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "142,531",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Bourse",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "825",
    "Price vs Market": "-655",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/142531",
  },
  {
    LL_ID: "9c8cbe09-71ea-432b-b252-f952e5954e1d",
    ll_name: "Mohamed Damak",
    RU_ID: "433,574",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "830",
    "Price vs Market": "-570",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/433574",
  },
  {
    LL_ID: "f0d0f74d-76b7-4bfb-b175-91af4cc17878",
    ll_name: "Shailendrasingh  Leeleea",
    RU_ID: "129,170",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "830",
    "Price vs Market": "-70",
    Available_From: "May 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/129170",
  },
  {
    LL_ID: "f0d0f74d-76b7-4bfb-b175-91af4cc17878",
    ll_name: "Shailendrasingh  Leeleea",
    RU_ID: "129,738",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "830",
    "Price vs Market": "-70",
    Available_From: "Apr 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/129738",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,057",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Enclos-St-Laurent",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "850",
    "Price vs Market": "-50",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626057",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,108",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "850",
    "Price vs Market": "-30",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626108",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,092",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "855",
    "Price vs Market": "-25",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626092",
  },
  {
    LL_ID: "c91756df-acb4-4f8f-8117-bdca8505a261",
    ll_name: "Henri Sitbon",
    RU_ID: "236,618",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "860",
    "Price vs Market": "-290",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/236618",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,080",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "860",
    "Price vs Market": "-20",
    Available_From: "Feb 14, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626080",
  },
  {
    LL_ID: "a250585f-e2a7-45dd-833d-87bea83186fe",
    ll_name: "Ahmed EL ABIDI",
    RU_ID: "123,745",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "875",
    "Price vs Market": "-835",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/123745",
  },
  {
    LL_ID: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    RU_ID: "512,138",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Observatoire",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "899",
    "Price vs Market": "-921",
    Available_From: "May 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/512138",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,244",
    Verified: "no",
    City: "paris",
    Neigbourhood: "M�nilmontant",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "910",
    "Price vs Market": "-70",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626244",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,052",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "910",
    "Price vs Market": "10",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626052",
  },
  {
    LL_ID: "c91756df-acb4-4f8f-8117-bdca8505a261",
    ll_name: "Henri Sitbon",
    RU_ID: "458,816",
    Verified: "yes",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "920",
    "Price vs Market": "-230",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/458816",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,131",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "950",
    "Price vs Market": "-40",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626131",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,050",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Butte-Montmartre",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "950",
    "Price vs Market": "50",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626050",
  },
  {
    LL_ID: "9d5b9b4a-790d-4a32-83fa-86207a5f559e",
    ll_name: "DoveVivo France",
    RU_ID: "640,270",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "970",
    "Price vs Market": "80",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640270",
  },
  {
    LL_ID: "497a5c61-6b40-4411-ab7c-ae5719fc40e9",
    ll_name: "Colivys",
    RU_ID: "626,134",
    Verified: "no",
    City: "paris",
    Neigbourhood: "Popincourt",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "990",
    "Price vs Market": "0",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "890",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/626134",
  },
  {
    LL_ID: "9d5b9b4a-790d-4a32-83fa-86207a5f559e",
    ll_name: "DoveVivo France",
    RU_ID: "640,272",
    Verified: "no",
    City: "paris",
    Neigbourhood: "OTHER_paris",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "990",
    "Price vs Market": "100",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/paris/for-rent:apartments/640272",
  },
];
